module.exports = __webpack_public_path__ + "5ff1441411e4f3ed4610ff1173d4610a.pdf";